var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.howlerState.state == "running"
    ? _c(
        "v-icon",
        {
          attrs: {
            color: "green",
          },
        },
        [_vm._v("\n  mdi-volume-high\n")]
      )
    : _c(
        "v-icon",
        {
          attrs: {
            color: "red",
          },
        },
        [_vm._v("\n  mdi-volume-mute\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }